import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/metadata_center',
  name: 'metadataCenter',
  component: Layout,
  redirect: '/metadata_center/administrative-regions',
  meta: {
    title: '元数据中心',
    icon: 'i-lucide:database',
  },
  children: [
    {
      path: 'administrative-regions',
      name: 'administrativeRegions',
      component: () => import('@/views/metadata_center/administrative-regions.vue'),
      meta: {
        title: '行政区划',
        icon: 'i-lucide:map-pinned',
      },
    },
    {
      path: 'business-dictionary',
      name: 'businessDictionary',
      component: () => import('@/views/metadata_center/business-dictionary.vue'),
      meta: {
        title: '业务字典',
        icon: 'i-lucide:book-open',
      },
    },
  ],
}

export default routes
